"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MegaMenuItemEnum = void 0;
var MegaMenuItemEnum;
(function (MegaMenuItemEnum) {
    MegaMenuItemEnum["Products"] = "products";
    MegaMenuItemEnum["SingleLevel"] = "singleLevel";
    MegaMenuItemEnum["SingleLevelWithIcons"] = "singleLevelWithIcons";
    MegaMenuItemEnum["MultipleLevel"] = "multipleLevel";
    MegaMenuItemEnum["ZeroLevel"] = "zeroLevel";
})(MegaMenuItemEnum || (exports.MegaMenuItemEnum = MegaMenuItemEnum = {}));
